import React, { Component, memo } from "react";
import { ModalBody, ModalHeader, ModalFooter, Button, Input } from "reactstrap";
import { translate, Trans } from "react-i18next";
import Switch from "./Switch";
import { showToast } from "../../helpers/toast";

const convertCardName = (name) => {
  const nameMap = {
    Status: "configurationCards.status",
    recent_alarms: "configurationCards.recent_alarms",
    recent_doorOpenings: "configurationCards.recent_doorOpenings",
    device_status: "configurationCards.device_status",
    location: "configurationCards.location",
    device_data: "configurationCards.device_data",
  };
  return nameMap[name] || name; // Return the mapped name or the original if not found
};
class ConfigurationModal extends Component {
  state = {
    cardVisibility: this.loadVisibilityFromLocalStorage() || [
      {
        name: "Status",
        status: true,
        layout: this.props.modalData.layouts[0],
      },
      {
        name: "recent_alarms",
        status: true,
        layout: this.props.modalData.layouts[1],
      },
      {
        name: "recent_doorOpenings",
        status: true,
        layout: this.props.modalData.layouts[2],
      },
      {
        name: "device_status",
        status: true,
        layout: this.props.modalData.layouts[3],
      },
      {
        name: "location",
        status: true,
        layout: this.props.modalData.layouts[4],
      },
      {
        name: "device_data",
        status: true,
        layout: this.props.modalData.layouts[5],
      },
    ],
  };

  handleSave = () => {
    this.saveVisibilityToLocalStorage();
    this.props.modalData.updateVisibility(this.state.cardVisibility);
    this.props.toggleModal();
    showToast(this.props.t("configurationCards.toastMessage"), "success");
  };

  saveVisibilityToLocalStorage = () => {
    try {
      localStorage.setItem(
        "defaultDashboardCardVisibilityUpdated",
        JSON.stringify(this.state.cardVisibility)
      );
    } catch (error) {
      console.error("Error saving visibility to localStorage:", error);
    }
  };

  loadVisibilityFromLocalStorage() {
    // Check for existing keys and clear them if they exist
    if (localStorage.getItem("dashboardCardVisibility")) {
      localStorage.removeItem("dashboardCardVisibility");
    }

    if (localStorage.getItem("defaultDashboardCardVisibility")) {
      localStorage.removeItem("defaultDashboardCardVisibility");
    }

    try {
      const savedVisibility = localStorage.getItem(
        "defaultDashboardCardVisibilityUpdated"
      );
      return savedVisibility ? JSON.parse(savedVisibility) : null;
    } catch (error) {
      console.error("Error loading visibility from localStorage:", error);
      return null;
    }
  }

  componentDidMount() {
    const loadedVisibility = this.loadVisibilityFromLocalStorage();
    if (loadedVisibility) {
      this.setState({ cardVisibility: loadedVisibility });
    }
  }

  toggleSwitch = (index) => {
    this.setState((prevState) => {
      const newCardVisibility = [...prevState.cardVisibility];
      newCardVisibility[index].status = !newCardVisibility[index].status;
      return { cardVisibility: newCardVisibility };
    });
  };

  render() {
    const { toggleModal, t } = this.props;

    return (
      <React.Fragment>
        <div className="mb-3" name="configuration">
          <ModalHeader tag="strong" toggle={toggleModal}>
            {t("configurationCards.customizeDashboard")}
          </ModalHeader>
          <ModalBody>
            {this.state.cardVisibility.map((card, index) => (
              <div
                key={card.name}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: "10px",
                }}
              >
                <span>{t(`configurationCards.${card.name}`)}</span>
                <Switch
                  active={card.status}
                  onClick={() => this.toggleSwitch(index)}
                />
              </div>
            ))}
          </ModalBody>
          <ModalFooter>
            <Button color="info" onClick={this.handleSave}>
              {t("configurationCards.save")}
            </Button>
            <Button color="secondary" type="button" onClick={toggleModal}>
              {t("configurationCards.cancel")}
            </Button>
          </ModalFooter>
        </div>
      </React.Fragment>
    );
  }
}

export default memo(translate("translations")(ConfigurationModal));
